import axios from 'axios';
import dayjs from 'dayjs';
import React, { FC, useEffect, useLayoutEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Setting, statusMessages, Subscription } from '../App';
import { CUSTOMER_API_URL } from '../constants';

export type StatusMessage = keyof typeof statusMessages;

export const SubscriptionList: FC<{ setting: Setting }> = ({ setting }) => {
  const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);

  useEffect(() => {
    axios
      .post(`${CUSTOMER_API_URL}?action=getSubscriptions`, {}, { headers: { Authorization: setting.token } })
      .then((response) => {
        setSubscriptions(response.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    const height = document.querySelector('body')!.scrollHeight + 100; // buffer;

    setting.resize(height);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptions]);

  const topic =
    subscriptions && subscriptions.length > 0 && subscriptions[0].shop!.mypageRemarks ? (
      <div className="huckleberry-subscription-list-memo">
        <p>{subscriptions[0].shop!.mypageRemarks}</p>
      </div>
    ) : (
      <></>
    );

  // TODO: 表示するランクを設定
  const rank = false ? (
    <div className="customer-rank">
      <span className="rank">Cランク</span>
      <span className="rank-benefits">3%割引</span>
    </div>
  ) : (
    <></>
  );

  return (
    <>
      <header>
        <h2 className="huckleberry-subscription-list-title huckleberry-subscription-list-color">カスタムマイページ2</h2>
        {topic}
        {rank}
      </header>
      <section>
        {subscriptions.map((subscription, index) => (
          <article className="subscription-history" key={index}>
            <dl className="huckleberry-subscription-list-detail">
              <dt className="huckleberry-subscription-list-id-title">定期購買ID</dt>
              <dd className="huckleberry-subscription-list-id">
                <Link to={`/subscriptions/${encodeURIComponent(subscription.subscriptionContractId)}`}>
                  {subscription.subscriptionContractId.split('/')[4]}
                </Link>
              </dd>
            </dl>
            <dl className="huckleberry-subscription-list-detail">
              <dt className="label">初回注文日</dt>
              <dd className="value">{dayjs(subscription.createdAt).format('YYYY年MM月DD日 HH:MM')}</dd>
            </dl>
            <dl className="huckleberry-subscription-list-detail">
              <dt className="label">ステータス</dt>
              <dd className="value">{statusMessages[subscription.status as StatusMessage]}</dd>
            </dl>
          </article>
        ))}
      </section>
    </>
  );
};
